import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";
import { Link } from "react-router-dom";
import { DocumentText1 } from "iconsax-react";
import { useLoader } from "../../Loader";
import Select from "react-select";

function Add(props) {
  const [formData, setFormData] = useState({
    plant: "",
    division: "",
    location: "",
    description: "",
    reason: "",
    costReduction: "",
    capacityIncrease: "",
    newProduct: "",
    quality: "",
    replacement: "",
    environmental: "",
    facility: "",
    other: "",
    capital: "",
    expense: "",
    capitalExpenditureSchedule: "",
    quotation: "",
  });
  const [isSubmit, setisSubmit] = useState(false);
  const [plants, setPlants] = useState([]);
  const [locations, setLocations] = useState([]);
  const [validated, setValidated] = useState(false);
  const [isEdit, setisEdit] = useState(false);
  const { startLoader, stopLoader } = useLoader();

  useEffect(() => {
    getPlantList();
    getOfficeLocation();
  }, []);

  const getOfficeLocation = () => {
    startLoader();
    utils
      .callAPI("get", `/sales/getLocationList`)
      .then((res) => {
        if (res?.result) {
          setLocations([
            { id: "", name: "Select Shipping Location..." },
            ...res.result,
          ]);
          stopLoader();
        } else {
          stopLoader();
        }
      })
      .catch(() => {
        setLocations([]);
        stopLoader();
      });
  };

  const getPlantList = () => {
    startLoader();
    utils
      .callAPI("get", `/purchaseorder/plant/list`)
      .then((res) => {
        if (res?.result) {
          setPlants(res.result);
          stopLoader();
        } else {
          stopLoader();
          setPlants([]);
        }
      })
      .catch(() => {
        stopLoader();
        setPlants([]);
      });
  };

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
      rowData: {},
    };
    props.onChange(propdata);
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;

    if (["capital", "expense"].includes(name) && value) {
      setFormData({
        ...formData,
        [name]: parseFloat(value).toFixed(2),
      });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (["capital", "expense"].includes(name)) {
      if (isNaN(value) || value < 0) return;
    }

    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleFileUpload = (e) => {
    const file = e.target.files[0];

    if (file) {
      console.log("File uploaded:", file);
      setFormData({
        ...formData,
        quotation: file,
      });
    }
  };

  const calculateTotal = () => {
    const capital = parseFloat(formData.capital) || 0;
    const expense = parseFloat(formData.expense) || 0;
    return (capital + expense).toFixed(2);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      setisSubmit(true);
    }
  };

  useEffect(() => {
    if (isSubmit) {
      startLoader();
      const bodyFormdata = new FormData();

      if (isEdit) {
        bodyFormdata.append("id", props?.rowData?.id);
      }
      bodyFormdata.append("plant_id", formData.plant);
      bodyFormdata.append("division", formData.division);
      bodyFormdata.append("location", formData.location);
      bodyFormdata.append("description", formData.description);
      bodyFormdata.append("reason", formData.reason);
      bodyFormdata.append("cost_reduction", formData.costReduction);
      bodyFormdata.append("capacity_increase", formData.capacityIncrease);
      bodyFormdata.append("new_product", formData.newProduct);
      bodyFormdata.append("quality", formData.quality);
      bodyFormdata.append("replacement", formData.replacement);
      bodyFormdata.append("enviromental", formData.environmental);
      bodyFormdata.append("facility", formData.facility);
      bodyFormdata.append("other", formData.other);
      bodyFormdata.append("capital", formData.capital);
      bodyFormdata.append("expense", formData.expense);
      bodyFormdata.append(
        "expenditure_schedule",
        formData.capitalExpenditureSchedule
      );
      bodyFormdata.append("quotation_attachment", formData.quotation);

      utils
        .callAPI("post", "/cer/save", bodyFormdata)
        .then((res) => {
          if (res) {
            setFormData({
              plant: "",
              division: "",
              location: "",
              description: "",
              reason: "",
              costReduction: "",
              capacityIncrease: "",
              newProduct: "",
              quality: "",
              replacement: "",
              environmental: "",
              facility: "",
              other: "",
            });
            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
            stopLoader();
          } else {
            setisSubmit(false);
            stopLoader();
          }
        })
        .catch((err) => {
          stopLoader();
          setisSubmit(false);
        });
    }
  }, [isSubmit]);

  useEffect(() => {
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      console.log("Edit ke ander toh gaya huin bhai..", props.rowData);
      setisEdit(true);
      setFormData({
        plant: props.rowData.plant_id || "",
        division: props.rowData.division || "",
        location: props.rowData.location || "",
        description: props.rowData.description || "",
        reason: props.rowData.reason || "",
        costReduction: props.rowData.cost_reduction || "",
        capacityIncrease: props.rowData.capacity_increase || "",
        newProduct: props.rowData.new_product || "",
        quality: props.rowData.quality || "",
        replacement: props.rowData.replacement || "",
        environmental: props.rowData.enviromental || "",
        facility: props.rowData.facility || "",
        other: props.rowData.other || "",
        capital: props.rowData.capital || 0,
        expense: props.rowData.expense || 0,
        capitalExpenditureSchedule: props.rowData.expenditure_schedule || "",
        quotation: props.rowData.quotation_attachment || "",
      });
    }
  }, [props?.rowData]);

  const locationOptions = locations.map((location) => ({
    value: location.id,
    label: location.name,
  }));

  return (
    <div className="section-body">
      <RB.Card className="card shadow">
        <RB.Card.Header>
          <h4>{isEdit ? "Edit" : "Add"} CER</h4>
          <div className="card-header-action">
            <Link className="btn btn-underline" onClick={handleBackClick}>
              Back
            </Link>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            {/* Plant, Division, Location Fields */}
            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formPlant"
                    label="Plant"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Select
                      name="plant"
                      value={formData.plant}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select Plant...</option>
                      {plants.map((plant) => (
                        <option key={plant.id} value={plant.id}>
                          {plant.plant_name}
                        </option>
                      ))}
                    </RB.Form.Select>
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formDivision"
                    label="Division"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      name="division"
                      value={formData.division}
                      onChange={handleInputChange}
                      placeholder="Enter Division"
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6} className="mt-3 mb-3">
                <Select
                  inputId="location"
                  name="location"
                  className="bom-productName-select"
                  classNamePrefix="location"
                  value={
                    locationOptions.find(
                      (opt) => opt.value === formData.location
                    ) || null
                  }
                  onChange={(selectedOption) =>
                    handleInputChange({
                      target: {
                        name: "location",
                        value: selectedOption?.value,
                      },
                    })
                  }
                  options={locationOptions}
                  placeholder="Select Location..."
                  isClearable
                  isSearchable
                />
              </RB.Col>
            </RB.Row>
            <RB.Row>
              <div className="mb-3">
                <RB.FloatingLabel
                  controlId="formDescription"
                  label="Description"
                  className="floating-label-fancy"
                >
                  <RB.Form.Control
                    as="textarea"
                    rows={3}
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    placeholder="Enter Description"
                    required
                  />
                </RB.FloatingLabel>
              </div>
            </RB.Row>
            <RB.Row>
              <div className="mb-3">
                <RB.FloatingLabel
                  controlId="formReason"
                  label="Reason"
                  className="floating-label-fancy"
                >
                  <RB.Form.Control
                    as="textarea"
                    rows={3}
                    name="reason"
                    value={formData.reason}
                    onChange={handleInputChange}
                    placeholder="Enter Reason"
                    required
                  />
                </RB.FloatingLabel>
              </div>
            </RB.Row>

            {/* Project Type Fields */}
            <h6 className="mt-2">Project Type</h6>
            <hr className="hr-lg mt-1" />
            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formCostReduction"
                    label="Cost Reduction"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      name="costReduction"
                      value={formData.costReduction}
                      onChange={handleInputChange}
                      placeholder="Enter Cost Reduction"
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formCapacityIncrease"
                    label="Capacity Increase"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      name="capacityIncrease"
                      value={formData.capacityIncrease}
                      onChange={handleInputChange}
                      placeholder="Enter Capacity Increase"
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formNewProduct"
                    label="New Product"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      name="newProduct"
                      value={formData.newProduct}
                      onChange={handleInputChange}
                      placeholder="Enter New Product"
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formQuality"
                    label="Quality"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      name="quality"
                      value={formData.quality}
                      onChange={handleInputChange}
                      placeholder="Enter Quality"
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formReplacement"
                    label="Replacement"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      name="replacement"
                      value={formData.replacement}
                      onChange={handleInputChange}
                      placeholder="Enter Replacement"
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formEnvironmental"
                    label="Environmental"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      name="environmental"
                      value={formData.environmental}
                      onChange={handleInputChange}
                      placeholder="Enter Environmental"
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formFacility"
                    label="Facility"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      name="facility"
                      value={formData.facility}
                      onChange={handleInputChange}
                      placeholder="Enter Facility"
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formOther"
                    label="Other"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      name="other"
                      value={formData.other}
                      onChange={handleInputChange}
                      placeholder="Enter Other"
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <h6 className="mt-2">Project Cost (INR)</h6>
                <hr className="hr-lg mt-1" />
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formCapital"
                    label="Capital"
                    className="floating-label-fancy mb-3"
                  >
                    <RB.Form.Control
                      type="text"
                      name="capital"
                      onBlur={handleBlur}
                      value={formData.capital}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*\.?\d*$/.test(value)) {
                          handleInputChange(e);
                        }
                      }}
                      placeholder="Enter Capital"
                    />
                  </RB.FloatingLabel>
                </div>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formExpense"
                    label="Expense"
                    className="floating-label-fancy mb-3"
                  >
                    <RB.Form.Control
                      type="text"
                      name="expense"
                      onBlur={handleBlur}
                      value={formData.expense}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*\.?\d*$/.test(value)) {
                          handleInputChange(e);
                        }
                      }}
                      placeholder="Enter Expense"
                    />
                  </RB.FloatingLabel>
                </div>
                <div className="mb-3 ">
                  <label className="form-label">Total</label>
                  <RB.Form.Control
                    type="text"
                    value={calculateTotal()}
                    readOnly
                    className="form-control-plaintext bg-light"
                  />
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formCapitalExpenditureSchedule"
                    label="CAPITAL EXPENDITURE SCHEDULE (INR)"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Select
                      name="capitalExpenditureSchedule"
                      value={formData.capitalExpenditureSchedule}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select Schedule...</option>
                      <option value="1Q">1Q</option>
                      <option value="2Q">2Q</option>
                      <option value="3Q">3Q</option>
                      <option value="4Q">4Q</option>
                    </RB.Form.Select>
                  </RB.FloatingLabel>
                </div>
                <div className="mb-3">
                  <label className="form-label">Quotation Attached</label>
                  <div className="d-flex align-items-center">
                    <RB.Form.Control
                      type="file"
                      name="quotation"
                      onChange={handleFileUpload}
                      accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.png"
                      required={!isEdit}
                      className="me-2 flex-grow-1"
                    />
                    {isEdit && formData.quotation && (
                      <a
                        href={props.rowData.attechPath}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-link p-0"
                        title="View Current Quotation"
                      >
                        <DocumentText1 />
                      </a>
                    )}
                  </div>
                </div>
              </RB.Col>
            </RB.Row>

            <RB.Row className="mt-3">
              <RB.Col className="text-end">
                <RB.Button variant="primary" type="submit" className="mt-3">
                  Submit
                </RB.Button>
              </RB.Col>
            </RB.Row>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default Add;
